// extracted by mini-css-extract-plugin
export default {"user_name":"StudentInformationsSection_user_name__LnqlU","user_info_container":"StudentInformationsSection_user_info_container__5YpA9"};